/*
 *
 * Theme: `@dbh/discount-label`.
 *
 */const THEME_KEY_DISCOUNT_LABEL="discountLabel";const modifyDiscountLabelTheme=()=>({[THEME_KEY_DISCOUNT_LABEL]:{chip:{margin:0}}});

export { THEME_KEY_DISCOUNT_LABEL, modifyDiscountLabelTheme as default };
